module.exports = __webpack_public_path__ + "img/cast_logo-footer.2dffe891.svg";